import React from 'react'
import { Link } from 'react-router-dom'

const ReadyToShip = () => {
  return (
    <div className="full-cat home-full-rts">
        <div className="container">
            <div className="row">
                <div className="col"><Link to="/category/shop?shipping=7+Days_Within+7+days&orderBy=default">
                <picture>                  
                  <source media="(min-width:990px)" srcSet="/images/ready-to-ship.jpg" />
                  <source media="(min-width:990px)" srcSet="/images/ready-to-ship-mobile.jpg" />
                  <img src="/images/ready-to-ship-mobile-s.jpg" alt="ready-to-ship" />
                </picture> 
                {/* <img src='/images/ready-to-ship.jpg' alt='ready-to-ship' /> */}
                    <div className='ovelaytext'>Ready To Ship <span>Styles at</span> <strong>Special Prices</strong>
                    <div className='rts-btn'><span>EXPLORE</span></div></div> </Link>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ReadyToShip
